export default __webpack_public_path__ + "static/hanukkah_hero-bde6d004528496383551547875c8cdf0.jpg";